<div class="main pt-3">
  <div class="container " style="max-width: 1400px">
    <div class="row spacing-20">
      <div class="card p-0">
        <div class="position-relative">
          <div class="card-header rounded-top bgi-size-cover" [style.background-image]="'url(' + event.header_url + ')'" style="background-position: 100% 50%; height: 300px;"></div>
          <app-button
            [variant]="'ghost'"
            [iconClass]="'fa fa-camera fs-2'"
            [size]="'lg'"
            class="position-absolute"
            style="top: 10px; right: 30px; z-index: 10; width: 35px; height: 35px; padding: 0;"
            (clicked)="openEditImageModal('header')"
          />
        </div>
        <div class="card-body mt-n19">
          <div class="m-0">
            <div class="d-flex flex-stack align-items-end pb-4 mt-n19">
              <div class="symbol symbol-125px symbol-lg-150px symbol-fixed position-relative mt-n3">
                @if (event.image_url){
                  <img [src]="event.image_url" alt="image" class="border border-white border-4" style="border-radius: 20px" />
                } @else {
                  <div
                    class="d-flex justify-content-center align-items-center border border-white border-4 bg-light"
                    style="border-radius: 20px; width: 100%; height: 100%; color: #555c61;"
                  >
                    <i class="fa-regular fa-building fs-7x m-5"></i>
                  </div>
                }
                <app-button
                  [variant]="'ghost'"
                  [iconClass]="'fa fa-camera'"
                  [size]="'sm'"
                  class="position-absolute"
                  style="bottom: 3px; right: 25px; width: 35px; height: 35px; border-radius: 50%; padding: 0;"
                  (clicked)="openEditImageModal('logo')"
                />
              </div>
            </div>
            <div class="d-flex flex-stack flex-wrap align-items-end">
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-2">
                  <a href="#" class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1">{{ event.event_name}}</a>
                  @if (event.status === 'cancelled') {
                    <span class="badge badge-light-danger ms-2">{{ 'manageEvent.status.cancelled' | translate }}</span>
                  } @else if (event.status === 'published') {
                    <span class="badge badge-light-success ms-2">{{ 'manageEvent.status.published' | translate }}</span>
                  } @else {
                    <span class="badge badge-light-warning ms-2">{{ 'manageEvent.status.draft' | translate }}</span>
                  }
                </div>
              </div>
              <div class="d-flex gap-2">
                @if (!isCancelled) {
                  @if (event.status === 'published') {
                    <app-button
                      [variant]="'outline'"
                      [label]="'manageEvent.actions.unpublish' | translate"
                      [iconClass]="'fa fa-eye-slash'"
                      [loading]="publishLoading"
                      (clicked)="unpublishEvent()"
                    />
                  } @else {
                    <app-button
                      [variant]="'primary'"
                      [label]="'manageEvent.actions.publishEvent' | translate"
                      [iconClass]="'fa fa-rocket'"
                      [loading]="publishLoading"
                      [disabled]="!canPublishEvent || paymentValidationLoading"
                      (clicked)="publishEvent()"
                    />
                  }
                }
                @if (canCancelEvent) {
                  <app-button
                    [variant]="'danger'"
                    [label]="'manageEvent.actions.cancelEvent' | translate"
                    [iconClass]="'fa fa-ban'"
                    (clicked)="openCancelEventModal()"
                  />
                }
                <a [routerLink]="['/event-details', event.event_id]" class="btn btn-ghost">
                  <i class="fa fa-external-link me-2"></i>{{ 'manageEvent.actions.viewEvent' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (isCancelled) {
      <div class="alert alert-danger d-flex align-items-center mb-4 mt-4" role="alert">
        <i class="fa fa-exclamation-triangle fs-2 me-3"></i>
        <div>
          <strong>{{ 'manageEvent.cancelled.bannerTitle' | translate }}</strong>
          <p class="mb-0 mt-1">{{ 'manageEvent.cancelled.bannerDescription' | translate }}</p>
        </div>
      </div>
    }

    @if (hasPaymentIssue && event.status !== 'published') {
      <div class="alert bg-light-danger border border-danger d-flex align-items-center mb-4 mt-4" role="alert">
        <i class="fa fa-credit-card fs-2 me-3 text-danger"></i>
        <div>
          <strong class="text-danger">{{ 'manageEvent.publishBlocked.title' | translate }}</strong>
          @if (!hasPaymentSetup) {
            <p class="mb-0 mt-1 text-gray-800">{{ 'manageEvent.publishBlocked.noPaymentSetup' | translate }}</p>
          } @else if (!event.payment_enabled) {
            <p class="mb-0 mt-1 text-gray-800">{{ 'manageEvent.publishBlocked.paymentDisabled' | translate }}</p>
          }
          <p class="mb-0 mt-2 text-gray-600 fs-7">
            <i class="fa fa-info-circle me-1"></i>
            {{ 'manageEvent.publishBlocked.pricedItems' | translate }}:
            @if (hasPricedClasses) { <span class="badge badge-danger me-1">{{ 'manageEvent.publishBlocked.classes' | translate }}</span> }
            @if (hasPricedServices) { <span class="badge badge-danger me-1">{{ 'manageEvent.publishBlocked.services' | translate }}</span> }
            @if (hasPricedPackages) { <span class="badge badge-danger me-1">{{ 'manageEvent.publishBlocked.packages' | translate }}</span> }
          </p>
        </div>
      </div>
    }

    <!-- Modern Tab Navigation -->
    <div class="profile-tabs-wrapper">
      <div class="profile-tabs">
        <button class="profile-tab" [class.active]="selectedTab === 'overview'" (click)="selectedTab = 'overview'">
          <i class="fa fa-info-circle me-2"></i>
          <span>{{ 'manageEvent.tabs.overview' | translate }}</span>
        </button>
        @if (showClasses) {
          <button class="profile-tab" [class.active]="selectedTab === 'classes'" (click)="selectedTab = 'classes'">
            <i class="fa fa-list me-2"></i>
            <span>{{ 'manageEvent.tabs.classes' | translate }}</span>
          </button>
        }
        @if (showCapacity) {
          <button class="profile-tab" [class.active]="selectedTab === 'capacity'" (click)="selectedTab = 'capacity'">
            <i class="fa fa-calendar-check me-2"></i>
            <span>{{ 'manageEvent.tabs.capacity' | translate }}</span>
          </button>
        }
        @if (showPackages) {
          <button class="profile-tab" [class.active]="selectedTab === 'packages'" (click)="selectedTab = 'packages'">
            <i class="fa fa-box-open me-2"></i>
            <span>{{ 'manageEvent.tabs.packages' | translate }}</span>
          </button>
        }
        @if (showTrainingSchedule) {
          <button class="profile-tab" [class.active]="selectedTab === 'training-schedule'" (click)="selectedTab = 'training-schedule'">
            <i class="fa fa-calendar-alt me-2"></i>
            <span>{{ 'manageEvent.tabs.schedule' | translate }}</span>
          </button>
        }
        <button class="profile-tab" [class.active]="selectedTab === 'services'" (click)="selectedTab = 'services'">
          <i class="fa fa-concierge-bell me-2"></i>
          <span>{{ 'manageEvent.tabs.services' | translate }}</span>
        </button>
        @if (showSchedule) {
          <button class="profile-tab" [class.active]="selectedTab === 'schedule'" (click)="selectedTab = 'schedule'">
            <i class="fa fa-calendar-days me-2"></i>
            <span>{{ 'manageEvent.tabs.schedule' | translate }}</span>
          </button>
          <button class="profile-tab" [class.active]="selectedTab === 'results'" (click)="selectedTab = 'results'">
            <i class="fa fa-trophy me-2"></i>
            <span>{{ 'manageEvent.tabs.results' | translate }}</span>
          </button>
        }
        <button class="profile-tab" [class.active]="selectedTab === 'announcements'" (click)="selectedTab = 'announcements'">
          <i class="fa fa-bullhorn me-2"></i>
          <span>{{ 'manageEvent.tabs.announcements' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'tasks'" (click)="selectedTab = 'tasks'">
          <i class="fa fa-list-check me-2"></i>
          <span>{{ 'manageEvent.tabs.tasks' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'contacts'" (click)="selectedTab = 'contacts'">
          <i class="fa fa-address-book me-2"></i>
          <span>{{ 'manageEvent.tabs.contacts' | translate }}</span>
        </button>
        @if (isEventOwner) {
          <button class="profile-tab" [class.active]="selectedTab === 'co-organisers'" (click)="selectedTab = 'co-organisers'">
            <i class="fa fa-users-gear me-2"></i>
            <span>{{ 'manageEvent.tabs.coOrganisers' | translate }}</span>
          </button>
        }
        <button class="profile-tab" [class.active]="selectedTab === 'sponsors'" (click)="selectedTab = 'sponsors'">
          <i class="fa fa-handshake me-2"></i>
          <span>{{ 'manageEvent.tabs.sponsors' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'expenses'" (click)="selectedTab = 'expenses'">
          <i class="fa fa-receipt me-2"></i>
          <span>{{ 'manageEvent.tabs.expenses' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'orders'" (click)="selectedTab = 'orders'">
          <i class="fa fa-credit-card me-2"></i>
          <span>{{ 'manageEvent.tabs.paymentOrders' | translate }}</span>
        </button>
        @if (isCancelled) {
          <button class="profile-tab" [class.active]="selectedTab === 'manual-refunds'" (click)="selectedTab = 'manual-refunds'">
            <i class="fa fa-hand-holding-dollar me-2"></i>
            <span>{{ 'manageEvent.tabs.manualRefunds' | translate }}</span>
          </button>
        }
      </div>
    </div>
    @if (selectedTab == 'overview') {
      <app-manage-event-overview
        [event]="event"
        [company]="event.company"
        (eventUpdated)="getEvent()"
      />
    }
    @else if (selectedTab == 'classes') {
      <app-manage-event-classes
        [event]="event"
        (dataChanged)="loadPaymentValidationData()"
      />
    }
    @else if (selectedTab == 'results') {
      <app-manage-event-results
        [event]="event"
        [initialClassId]="selectedClassId"
      />
    }
    @else if (selectedTab == 'capacity') {
      <div class="card mb-5">
        <div class="card-body">
          <app-wizard-step-capacity
            [event]="event"
          />
        </div>
      </div>
    }
    @else if (selectedTab == 'packages') {
      <app-manage-training-packages
        [event]="event"
        (dataChanged)="loadPaymentValidationData()"
      />
    }
    @else if (selectedTab == 'services') {
      <app-manage-event-service
        [event]="event"
        (dataChanged)="loadPaymentValidationData()"
      />
    }
    @else if (selectedTab == 'sponsors') {
      <app-manage-event-sponsor
        [event]="event"
      />
    }
    @else if (selectedTab == 'tasks') {
      <app-manage-event-tasks
        [event]="event"
      />
    }
    @else if (selectedTab == 'contacts') {
      <app-manage-event-contacts
        [event]="event"
      />
    }
    @else if (selectedTab == 'co-organisers') {
      <app-manage-event-co-organisers
        [event]="event"
      />
    }
    @else if (selectedTab == 'schedule') {
      <app-manage-event-schedule
        [event]="event"
      />
    }
    @else if (selectedTab == 'training-schedule') {
      <app-manage-training-schedule
        [event]="event"
      />
    }
    @else if (selectedTab == 'announcements') {
      <app-manage-event-announcements
        [event]="event"
      />
    }
    @else if (selectedTab == 'expenses') {
      <app-manage-event-expenses
        [event]="event"
      />
    }
    @else if (selectedTab == 'orders') {
      <app-manage-event-orders
        [event]="event"
      />
    }
    @else if (selectedTab == 'manual-refunds') {
      <app-manual-refunds-list
        [event]="event"
      />
    }
  </div>
</div>
